export default "/images/vendor/flag-icon-css/flags/1x1/ax.svg?c260e9a581b4c4415f206107819ae3b4";